import React, { useEffect } from "react";
import Gujarat_State_Healthcare_PDF_1 from "../../assets/pdf/notifications/gujarat-state-allied-and-healthcare-council-rules-2024.pdf";
import National_Commission_PDF_2 from "../../assets/pdf/notifications/national-commission-for-allied-and-healthcare-professions-act-2021.pdf";
import Members_Notification_PDF from "../../assets/pdf/notifications/Members Notification 20-12-2024.pdf";
import Autonomous_Board_Notification_PDF from "../../assets/pdf/notifications/Autonoumas Board Notification-10-09-2026.pdf";
import Background_Member2 from "../../assets/images/inner-banner.jpg";
import { Link } from "react-router-dom";

const ActAndRules = () => {
    document.title = "Act & Rules | Gujarat State Allied and Healthcare Council";
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div className="wrappermain">
                <div
                    className="banner-image wrappermain"
                    style={{
                        backgroundImage: "url(" + Background_Member2 + ")",
                        backgroundSize: "fill",
                        backgroundPosition: "right",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        padding: "25px 0",
                    }}
                >
                    <div className="banner-inner-breadcrumb">
                        <div className="container">
                            <nav aria-label="breadcrumb">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={"/"}>
                                            Home
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Act & Rules</li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="act-and-rules-main">
                    <div className="container">
                        <h2 className="m-0 py-2 section-title">Act & Rules</h2>
                        <div className="act-and-rules py-2">
                            <a href={Gujarat_State_Healthcare_PDF_1} target="_blank">
                                Gujarat State Allied and Healthcare Council Rules, 2024
                            </a>
                            <a href={National_Commission_PDF_2} target="_blank">
                                National Commission for Allied and Healthcare Professions Act-2021
                            </a>
                            <a href={Members_Notification_PDF} target="_blank">
                                Members Notification - December 20, 2024
                            </a>
                            <a href={Autonomous_Board_Notification_PDF} target="_blank">
                                Autonomous Board Notification - September 10, 2026
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ActAndRules;
